<template>
    <div class="awaiting--aproval">
        <template v-if="notifications.length > 0">
            <transition-group name="notification-list" tag="div" class="notifications" appear>
                <notification
                    appear
                    v-for="(notification, idx) in notifications"
                    :key="idx"
                    :notification="notification"
                ></notification>
            </transition-group>
        </template>
        <div class="nav">
            <div class="nav--item logout" @click.prevent="logout">
                <span>Kirjaudu ulos</span>
            </div>
        </div>
        <main class="awaiting--approval--content">
            <div class="notice">
                <p>Kirjauduit sisään onnistuneesti.</p>
                <p>Odota kunnes käyttäjäsi tunnistetaan ylläpitäjäksi.</p>
            </div>
        </main>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import notification from './Notification'

export default {
    name: 'AwaitingApproval',
    components: {
        notification
    },
    data: () => {
        return {}
    },
    props: {},
    computed: {
        ...mapState('auth', ['notifications', 'currentUser'])
    },
    methods: {
        ...mapActions('auth', ['attemptLogout', 'addNotification']),
        logout() {
            this.attemptLogout()
                .then(() => {
                    this.handleSuccessfulLogout()
                })
                .catch((err) => {
                    this.handleUnsuccessfulLogout(err)
                })
        },
        handleSuccessfulLogout() {
            this.transferToLoginScreen()
            this.addNotification({
                title: 'Kirjauduttu ulos',
                text: 'Kirjauduit onnistuneesti ulos.',
                type: 'success'
            })
        },
        handleUnsuccessfulLogout(err) {
            this.addNotification({
                title: 'Hups! Kävi jotain hassusti.',
                text: 'Uloskirjautuminen epäonnistui',
                type: 'fail'
            })
        },
        transferToLoginScreen() {
            this.$router.push(this.$route.query.redirect || '/login')
        }
    }
}
</script>

<style scoped>
.nav {
    display: flex;
    justify-content: flex-end;
    padding: 0;
    box-shadow: inset 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.nav--item {
    text-transform: lowercase;
    color: var(--font-2);
    font-weight: 300;
    margin: 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.86rem;
    padding: 0.7em 1em;
    padding-bottom: 0.7em;
}

.logout {
    cursor: pointer;
    background: var(--accent-1);
    background: var(--accent-gradient);
    margin-right: 0;
    color: color(--font-1);
    font-weight: 400;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

awaiting--approval {
    width: 100%;
    height: 100%;
}

.awaiting--approval--content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.awaiting--approval--content p:first-of-type {
    margin-top: 4em;
}

.awaiting--approval--content p {
    margin: 0;
    line-height: 1.7;
    font-size: 1.1rem;
    font-weight: 300;
    margin: 0;
}
</style>
